

























































import { ResourceUtils } from '@/util/resourceUtils';
import { Component, Vue } from 'vue-property-decorator';
@Component({
    props: {
        accessKey: Object,
    },
})
export default class AccessKeyModal extends Vue {
    private show = true;
    private disableButton = false;

    private copyText() {
      const copyText = document.getElementById('myInput') as HTMLInputElement;
      if (copyText) {
        copyText.select();
        document.execCommand('Copy');
      }
    }
    private downloadAccessKeyCSVFile() {
      const accessKeyData = [ {
        secretAccessKey: this.$props.accessKey.secret_key,
      }];
      const headers = ['Secret Access Key'];
      const accessKeyRows = accessKeyData.map((data) =>
          `${data.secretAccessKey}`,
      );
      const accessKeyCSVFile = headers.concat(accessKeyRows).join('\n');
      ResourceUtils.downloadFileIntoDevice(accessKeyCSVFile, 'accessKey.csv');
      this.disableButton = true;
    }
    private close() {
        this.$emit('close');
    }
}
